import React, {useEffect, useState} from "react";
import LiveVideo from "../../components/LiveVideo";
const url = new URL(window.location.href);

const LivePage =()=> {
  useEffect(() => {
  },[]);
  return (
    <>
      <LiveVideo
        dispositivo= {url.searchParams.get("dispositivo")}
        token= {url.searchParams.get("token")}
      />
    </>
  );
}
export default LivePage;
